import React from 'react';

import GoogleLoginButton from './GoogleLoginButton';
import MicrosoftLoginButton from './MicrosoftLoginButton';
import {
  socialLoginButtonDefaultProps,
  socialLoginButtonProps,
} from './propTypes';
import propTypes from '../../propTypes';

export default function SocialLoginButton({ type, ...rest }) {
  switch (type) {
    case 'GOOGLE':
      return <GoogleLoginButton {...rest} />;
    case 'MICROSOFT':
      return <MicrosoftLoginButton {...rest} />;
    default:
      return null;
  }
}
SocialLoginButton.propTypes = {
  type: propTypes.socialAccountType.isRequired,
  ...socialLoginButtonProps,
};

SocialLoginButton.defaultProps = {
  ...socialLoginButtonDefaultProps,
};
